import script from "./DefaultFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultFilter.vue?vue&type=script&setup=true&lang=js"

import "./DefaultFilter.vue?vue&type=style&index=0&id=46bd2f4e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46bd2f4e"]])

export default __exports__